import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const BottomActionsContainer = styled.div({
  display: "flex",
  justifyContent: "flex-end",
  margin: "0.625rem 0px 0.625rem auto",

  '>div:first-child':{
      flex:1
  }
});
export const BLListCont = styled.div((props) => ({
    marginTop:'1rem',
    width:'80vw',
    // maxWidth:'90vw',
  
    '.ui.table':{
      borderWidth:0
    },
  
    '.ReactTable .rt-thead.-header':{
      boxShadow:'none',
      background: '#eaeff5'
    },
  
    '.ReactTable':{
      borderRadius:'0.5rem'
    },
  
    '.ReactTable .rt-thead .rt-th':{
      borderRight: 0
    },
  
    '.ReactTable .rt-tbody .rt-td':{
      borderRight: 0
    },
  
    '.-padRow':{
      cursor:'default !important'
    },
  
    '.ReactTable .rt-tr':{
      cursor:'pointer'
    }
  
}))
  
export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const BLStdCont = styled.div((props) => ({
  'div.fieldInput input:disabled':{background:'#fff !important'},
  'div.fieldInput .ui.disabled':{background:'#fff !important'},
  'div.fieldInput textarea:disabled':{background:'#fff !important'},
}))

export const BLContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop:'1rem',

  '.headerText':{
    fontWeight:'bold',
    fontSize:'1.2rem',
    color:`${v.ezMainColor}`
  },

  '.stepTitle':{
    color:`${v.ezMainColor}`,
    fontSize:'1.2rem',
    fontWeight:'bold'
  }
})
export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(34,36,38,.15)',
  borderRadius: '.28571429rem',
  padding: '0.2rem 0.5rem',
  minHeight: '10rem',
  background:'#fff',

  '.title': {
    fontWeight: 'bold',
    color: `${v.ezMainColor}`
  },

  '.stBold':{
    fontWeight:'bold'
  },

  '.rowI': {
    display:'flex',
    '>div:first-child':{
      flex:3.5,
      marginRight:'0.2rem'
    },
    '>div':{
      flex:1
    }
  }
});
export const TablePO = styled.div({
  width: '50%',
  paddingRight: '0.9357rem',

  '.ReactTable':{
    borderWidth:'0 !important'
  },

  '.-center': {
    visibility: 'hidden !important',
    height:'1rem',
    flex:6
  },

  '.-pagination':{
    boxShadow:'none !important',
    borderTop:'0 !important'
  },  

  '.rt-tr.-odd':{
    background:'none !important'
  },

  '.rt-tr.-even':{
    background:'none !important'
  },

  '.rt-tr-group':{
    borderBottom:'none !important'
  },

  '.rt-thead.-header':{
    display:'none !important'
  },

  '.rt-item':{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    border:'1px solid rgba(34,36,38,.15)',
    padding:'0.4rem',
    borderRadius:'0.5rem',
    background: '#F5F6FA',
    fontWeight:'bold'
  }

});

export const RowFields = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
})
export const FooterCont = styled.div({
  display: 'flex',
  flexDirection:'column',
  marginTop:'1rem',

  '>div':{
    display:'flex',
    flex:1,
    marginTop:'1rem',
  },

  '.title':{
    display:'flex',
    justifyContent:'flex-end',
    alignItems:'center',
    fontWeight:'bold',
    flex:1,

    '.halfRow':{
      width:'5%',
      marginLeft:'1rem',

      '.fieldRow':{
        marginBottom:0
      }
    }
  },

  '.value':{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    width:'8rem',

    '.amount':{
      width:'5rem',
      textAlign:'center'
    },
    '.currency':{
      width:'5rem',
      textAlign:'center'
    }
  }
})

export const LinkInfo = styled.div({
  cursor:'pointer',
  textDecoration: 'underline',
  color: '#FBBF66'
})

export const FileRRR = styled.div({
  width: '31%',
  display: 'flex',
  flexDirection: 'column',
  marginRight: '1rem',

  '>div':{
    width:'100% !important'
  }
})